import { useRef } from 'react';
import { useFrameHandler } from '../useFrameHandler';
import { captureKiCodeTarget } from './captureTarget';
import { createKiCodeCapture } from './kiCodeCapture';

/** `appApiName` is read whenever a capture looks for its target, so it must return the session's live binding. */
export const useKiCodeCapture = (
  enabled: boolean,
  appApiName: () => string | undefined
) => {
  const appApiNameRef = useRef(appApiName);
  appApiNameRef.current = appApiName;

  return useFrameHandler(enabled, () =>
    createKiCodeCapture({
      capture: (message, context) =>
        void captureKiCodeTarget(
          message,
          () => appApiNameRef.current(),
          context
        ),
    })
  ).handle;
};
